import { useEffect, useState } from 'react';

export function useOnline({
    changeHandler,
}: {
    changeHandler?: (isOnline: boolean) => void;
} = {}): boolean {
    const [isOnline, setIsOnline] = useState(() => window.navigator.onLine);

    useEffect(() => {
        const abortController = new AbortController();

        window.addEventListener('online', () => setIsOnline(true), { signal: abortController.signal });
        window.addEventListener('offline', () => setIsOnline(false), { signal: abortController.signal });

        return () => abortController.abort();
    }, []);

    useEffect(() => {
        if (changeHandler)
            changeHandler(isOnline);
    }, [isOnline, changeHandler]);

    return isOnline;
}
